const colors = {
  available: '#090',
  below_required: '#da4f49',
  on_required: '#faa732',
  on_buffer: '#FF0',
  below_buffer: '#FF0',
  above_buffer: '#090',
  not_in_service_exception: 'gray',
  not_in_service_understaffed: 'red',
  not_in_service: 'silver',
  not_set: '#fff'
};

export const backgrounds = {
  below_required: '#a81515',
  on_required: '#e78905',
  below_buffer: '#ffff33',
  on_buffer: '#ffff33',
  above_buffer: '#10b310',
  not_in_service_exception: 'gray',
  not_in_service_understaffed: 'red',
  not_in_service: 'silver',
  not_set: '#fff'
};

export const fontColors = {
  below_required: '#fff',
  on_required: '#fff',
  on_buffer: '#4a4a4a',
  below_buffer: '#4a4a4a',
  above_buffer: '#fff',
  not_in_service_exception: '#4a4a4a',
  not_in_service_understaffed: '#fff',
  not_in_service: '#4a4a4a',
  not_set: '#000',
  default: 'white'
};

export const worstLevel = warningLevels => {
  return Object.keys(backgrounds).find(status => warningLevels.includes(status));
};

// Returns the background that matches the worst warning level
export const worstLevelBackground = warningLevels => {
  return backgrounds[worstLevel(warningLevels)];
};

// Returns the font color that matches the worst warning level
export const worstLevelFontColor = warningLevels => {
  return fontColors[worstLevel(warningLevels)];
};

export const getWarningLevelsFromAvailabilityRequirements = (
  availabilityRequirementsArray,
  availabilityRequirementsState
) => {
  return availabilityRequirementsArray
    .map(ar => {
      const wlItem = availabilityRequirementsState[ar.id];
      if (!wlItem) return null;
      const serviceOrWarningLevel = wlItem.serviceLevel === 'in_service' ? wlItem.warningLevel : wlItem.serviceLevel;
      return serviceOrWarningLevel;
    })
    .filter(Boolean);
};

export default colors;
